'use strict'

/**
 * Хранилище для состояний сети
 */

import * as types from '@/store/types'

const state = {
  socket: {
    connected: null
  }
}

const mutations = {
  [types.NETWORK.socket.update.connected]: (store, value) => {
    store.socket.connected = value
  }
}

const actions = {
  [types.NETWORK.socket.update.connected] (context, { connected }) {
    context.commit(types.NETWORK.socket.update.connected, connected)
  }
}

export default {
  state,
  mutations,
  actions
}
